export default __webpack_public_path__ + "img/iss.8ad00ed0.png";